export const TYPESENSE_SELECT_OPTIONS_WINDOW_SIZE = 50;
